<template>
    <div class="payment-record">
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :searchTotalTitle="config.searchTotalTitle"
            :currentPage="searchParams.pageNo"
            @updateStatus-btn="handleUpdateStatus"
            @btnClick="handleBtnClick"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            moduleCode="paymentRecordLSP"
            searchId="paymentRecordQuery"
            pageID="paymentRecord"
        >
            <div slot="table-module-btn">
                <reportExport
                    #default="{ submit }"
                    reportCode="PAY_RECORD_EXPORT"
                >
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span class="mgl-10">
                            <el-button
                                v-has="'payment-record-export'"
                                class="bigData-btn-payment-record-export"
                                icon="icon-daochu"
                                size="mini"
                                @click="exportFile(submit)"
                            ></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
            </div>
        </m-pane>
        <!-- 包含的分账单弹窗 -->
        <split-detail-dialog
            v-if="splitDetailDialogShow"
            :splitDetailDialogShow.sync="splitDetailDialogShow"
            :componentData="rowData"
            @refresh="refresh"
        ></split-detail-dialog>
    </div>
</template>
<script>
import mPane from '@/components/otpPanel';
import config from './config.js';
import { mapState } from 'vuex';
import { formatSearchData, validateSearchData, formatTotalDataList } from './util.js';
import * as api from '@/modules/transport/otp/api/paymentRecord.js';
import reportExport from '@/components/lots/reportExportPlugin';
import bigDataLog from '@/utils/bigDataLog';
export default {
    name: 'paymentRecord',
    components: {
        mPane,
        reportExport,
        splitDetailDialog: () => import('./components/splitDetailDialog.vue')
    },
    data () {
        return {
            config,
            loading: false,
            totalData: [],
            pageTotal: 0,
            isFirstSearch: true,
            searchParams: {
                pageSize: 10,
                pageNo: 1,
                param: {}
            },
            rowData: {},
            selected: [],
            splitDetailDialogShow: false
        };
    },
    computed: {
        ...mapState({
            user: state => state.user,
            currentTenant: state => state.currentTenant,
            supplier: state => state.supplier
        })
    },
    methods: {
        /**
         * @description 查询条件变化触发事件
         * @param {Object} data 查询条件
         */
        searchChange (data) {
            // 格式化查询条件
            const _searchData = formatSearchData(data);
            // 查询条件校验
            const isQueryOk = validateSearchData(_searchData);
            // 执行操作
            if (!isQueryOk) return;
            this.searchParams = this.getSearchData(_searchData);
            this.getList();
            this.isFirstSearch = false;
        },
        /**
         * @description 获取列表数据
         * @param {object} 查询条件
         * @return {list} 列表数据
         */
        getList () {
            this.loading = true;
            this.queryCount();
            api.queryPage(this.searchParams)
                .then((res) => {
                    if (res && +res.code === 0) {
                        this.totalData = formatTotalDataList(res.data.list || [], this.dictData);
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                });
        },
        getSearchData (data) {
            const _searchData = {
                ...this.searchParams,
                pageNo: 1,
                param: {
                    ...data,
                    carrierCodeList: [this.supplier.supplierCode] // 供应商编码-LSP
                }
            };
            return _searchData;
        },
        queryCount () {
            api.queryCount(this.searchParams.param)
                .then((res) => {
                    if (res && +res.code === 0) {
                        this.pageTotal = res.data || 0;
                    }
                })
                .catch(() => { });
        },
        /**
         * @description 导出
        */
        exportFile (submit) {
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            submit({
                ...this.searchParams.param,
                tenantCode: this.currentTenant.tenantCode,
                beginDate: '2010-07-26 00:00:00', // 没有的字段，为了后端导出任务片段必填
                endDate: '2030-07-26 00:00:00',
                carrierCodeList: [this.supplier.supplierCode],
                requestResults: this.$refs.tablePage.tableList
            });
            this.isFirstSearch = false;
        },
        handleBtnClick (val, index, row, prop) {
            if (prop === 'divideNoCount') {
                bigDataLog.sendDetailMessageByKey('bigData-btn-payment-record-divideNoCount');
                this.rowData = row;
                this.splitDetailDialogShow = true;
            }
        },
        handleUpdateStatus (data) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-payment-record-updateStatus');
            api.updatePayStatus({ batchNo: data.batchNo, payAccount: data.payAccount }).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('更新成功');
                    this.getList();
                }
            }).catch(() => { });
        },
        // 刷新页面
        refresh (dialogVisible) {
            this[dialogVisible] = false;
            this.getList();
        },
        // 选中表格行
        selectChange (data) {
            this.selected = data;
        },
        // 切换当前页数
        pageChange (pageNo) {
            this.searchParams.pageNo = pageNo;
            this.getList();
        },
        // 切换分页显示条数
        sizeChange (pageSize) {
            this.searchParams.pageNo = 1;
            this.searchParams.pageSize = pageSize;
            this.getList();
        }
    }
};
</script>
<style lang='less' scoped>
.payment-record {
    /deep/.otp-table {
        .el-table {
            min-height: calc(~'100vh - 186px') !important;
            max-height: calc(~'100vh - 186px') !important;
            .el-table__fixed {
                height: calc(100% - 14px) !important;
            }
        }
    }
}

</style>